import * as React from "react";

const CalendarIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <g
            stroke="#686A71"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            clipPath="url(#clip0_855_20876)"
        >
            <path d="M15.375 5.133H.625V3.62c0-1.035.84-1.875 1.875-1.875h11c1.036 0 1.875.84 1.875 1.875zM3.472 1.135V2.73M8 1.135V2.73M12.527 1.135V2.73M4.345 8.431v-.028M8 8.403v.028M11.655 8.403v.028M4.345 11.595v-.028M8 11.567v.028M11.655 11.567v.028"></path>
            <path d="M15.375 9.88V5.133H.625v7.857c0 1.036.84 1.875 1.875 1.875h11c1.03 0 1.867-.831 1.875-1.86"></path>
        </g>
        <defs>
            <clipPath id="clip0_855_20876">
                <path fill="#fff" d="M0 0h16v16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default CalendarIcon;
